import React from 'react';
import Footer from './components/Footer';

export default function AboutPage() {
  return (
    <div className="public-page-shell">
      <main className="public-page-main">
        <section className="public-hero-panel">
          <div className="public-hero-content">
            <div>
              <p className="hero-eyebrow">About LankaTutor</p>
              <h1 className="public-hero-title">Built to make finding the right teacher feel trusted, calm, and premium.</h1>
            </div>
            <p className="public-hero-copy">
              LankaTutor connects students and families with qualified Sri Lankan teachers through a cleaner discovery experience,
              clear profile presentation, and a platform designed to feel dependable on every screen size.
            </p>
            <div className="public-stat-grid">
              <article className="public-stat-card">
                <p className="public-stat-value">Islandwide</p>
                <p className="public-stat-label">Browse tutors across districts without losing the personal feel of local learning.</p>
              </article>
              <article className="public-stat-card">
                <p className="public-stat-value">Student First</p>
                <p className="public-stat-label">Make it easier for families to compare expertise, teaching medium, and contact options.</p>
              </article>
              <article className="public-stat-card">
                <p className="public-stat-value">Professional</p>
                <p className="public-stat-label">Present every teacher with the clarity and polish expected from a trusted education brand.</p>
              </article>
            </div>
          </div>
        </section>

        <section className="public-section-grid">
          <article className="public-surface-card">
            <h3>Our Mission</h3>
            <p>Bridge the gap between students and expert teachers across Sri Lanka with a discovery experience that feels simple, modern, and credible.</p>
          </article>
          <article className="public-surface-card">
            <h3>For Students</h3>
            <p>Find tutors for school subjects, Advanced Level preparation, and long-term academic growth without getting lost in cluttered listings.</p>
          </article>
          <article className="public-surface-card">
            <h3>For Teachers</h3>
            <p>Showcase your expertise with a profile that highlights subject strength, location, medium, and teaching materials in a more polished way.</p>
          </article>
        </section>

        <section className="public-section-grid" style={{ marginTop: '1.25rem' }}>
          <article className="public-surface-card">
            <h2>What makes the platform feel different</h2>
            <ul className="public-inline-list">
              <li>
                <strong>Cleaner discovery</strong>
                <span>Search, filter, and compare tutors with less friction on both mobile and desktop.</span>
              </li>
              <li>
                <strong>Better presentation</strong>
                <span>Teacher profiles are built to communicate trust, subject fit, and professional credibility quickly.</span>
              </li>
              <li>
                <strong>Designed for Sri Lanka</strong>
                <span>From teaching mediums to district-based discovery, the product reflects the way local education decisions are made.</span>
              </li>
            </ul>
          </article>
        </section>
      </main>
      <Footer />
    </div>
  );
}
